<script setup lang="ts">
// Le clic sur le logo rechargeait l'app quand on était déjà sur l'accueil :
// personne ne le découvrait. Le rechargement est désormais exposé explicitement
// par ReloadAppButton.vue dans la navbar.
import { currentBrand } from "@/brand";

withDefaults(
  defineProps<{
    /** Navbar rétrécie : on ne garde que l'icône, sans le nom de la marque. */
    compact?: boolean;
  }>(),
  { compact: false },
);
</script>

<template>
  <router-link
    :to="{ name: 'home' }"
    class="navbar-brand d-inline-flex align-items-center gap-2"
    :aria-label="currentBrand.name"
  >
    <template v-if="currentBrand.id === 'inspexio'">
      <span class="brand-mark" aria-hidden="true" />
      <span v-if="!compact" class="brand-name">inspexio</span>
    </template>
    <span v-else class="fs-4 fw-bolder">DR</span>
  </router-link>
</template>

<style lang="scss" scoped>
// Le logo est posé en masque plutôt qu'en <img> : sa couleur reste pilotable
// en CSS, indispensable pour le mode sombre où le bleu de la charte
// disparaîtrait sur le fond.
.brand-mark {
  --brand-mark-color: var(--bs-primary);

  display: block;
  height: 1.75rem;
  aspect-ratio: 1211 / 1373; // dimensions du tracé de la charte
  background-color: var(--brand-mark-color);
  -webkit-mask: url("/brand/inspexio/mark.svg") center / contain no-repeat;
  mask: url("/brand/inspexio/mark.svg") center / contain no-repeat;
}

[data-bs-theme="dark"] .brand-mark {
  --brand-mark-color: #{white};
}

// Pas de couleur imposée : le nom hérite de celle de la navbar, donc noir en
// clair et lisible en sombre, comme le faisait le « DR » qu'il remplace.
.brand-name {
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.01em;
}
</style>
